import React from 'react'
import classNames from 'classnames'
import { SIZES } from '../utils/constant'

const Line = props => {

	const {
		percent,
		size,
		children,
		strokeColor,
		height
	} = props

	const progressBackgroundClass = classNames(
		'progress-bg',
		'progress-text',
		size === SIZES.SM ? 'h-1.5' : 'h-2',
		`${strokeColor}`
	)
		let latestPercent =`${percent}%`
	if(percent === 'N/A'){
		latestPercent = percent
	}
	
	
	return (
		<>
			<div className="progress-wrapper">
				<div className="progress-inner">
					<div className={progressBackgroundClass} style={{width: `${latestPercent}`,height:`${height}`}}><div>{percent}</div></div>
				</div>
			</div>
			{children}
		</>
	)
}

export default Line